import { render, staticRenderFns } from "./OrgModelStats.vue?vue&type=template&id=199956c5&scoped=true"
import script from "./OrgModelStats.vue?vue&type=script&lang=js"
export * from "./OrgModelStats.vue?vue&type=script&lang=js"
import style0 from "./OrgModelStats.vue?vue&type=style&index=0&id=199956c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199956c5",
  null
  
)

export default component.exports